import React, { useState } from 'react';
import { COUNTRY_COORDS } from './ClockWeather';

const THEMES = [
  { id: 'light', label: 'White', icon: '☀️' },
  { id: 'dark', label: 'Black', icon: '🌑' },
  { id: 'multicolor', label: 'Multicolor', icon: '🎨' },
];

export default function QuickStatusBar({ criticalCount = 0 }) {
  const [mode, setMode] = useState(() => localStorage.getItem('nv_mode') || 'off');
  const [country, setCountry] = useState(() => localStorage.getItem('nv_country') || 'IN');
  const [theme, setTheme] = useState(() => localStorage.getItem('cu_theme') || 'light');
  const [brightness, setBrightness] = useState(() => +(localStorage.getItem('nv_brightness') || 100));
  const [warmth, setWarmth] = useState(() => +(localStorage.getItem('nv_warmth') || 0));

  const setModeAndSync = (m) => {
    setMode(m);
    localStorage.setItem('nv_mode', m);
    window.dispatchEvent(new Event('cu_mode_changed'));
  };

  const setBrightnessAndSync = (b) => {
    setBrightness(b);
    localStorage.setItem('nv_brightness', b);
    window.dispatchEvent(new Event('cu_mode_changed'));
  };

  const setWarmthAndSync = (w) => {
    setWarmth(w);
    localStorage.setItem('nv_warmth', w);
    window.dispatchEvent(new Event('cu_mode_changed'));
  };

  const setCountryAndSync = (c) => {
    setCountry(c);
    localStorage.setItem('nv_country', c);
    window.dispatchEvent(new Event('cu_country_changed'));
  };

  const setThemeAndSync = (t) => {
    setTheme(t);
    localStorage.setItem('cu_theme', t);
    document.documentElement.setAttribute('data-theme', t);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: 'var(--text-secondary)' }}>
        <span>🌙</span>
        <div style={{ display: 'flex', gap: 4 }}>
          {['off', 'manual', 'auto'].map(m => (
            <button key={m} onClick={() => setModeAndSync(m)} style={{
              padding: '3px 9px', borderRadius: 6, fontSize: 11, cursor: 'pointer',
              border: '1px solid var(--border)',
              background: mode === m ? 'var(--accent)' : 'transparent',
              color: mode === m ? '#fff' : 'var(--text-secondary)',
            }}>{m.charAt(0).toUpperCase() + m.slice(1)}</button>
          ))}
        </div>

        {mode === 'manual' && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <span style={{ fontSize: 10 }}>☀️</span>
              <input type="range" min="40" max="100" value={brightness}
                onChange={e => setBrightnessAndSync(+e.target.value)}
                style={{ width: 70 }} />
              <span style={{ fontSize: 10, width: 28 }}>{brightness}%</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <span style={{ fontSize: 10 }}>🔥</span>
              <input type="range" min="0" max="60" value={warmth}
                onChange={e => setWarmthAndSync(+e.target.value)}
                style={{ width: 70 }} />
              <span style={{ fontSize: 10, width: 28 }}>{warmth}%</span>
            </div>
          </div>
        )}

        {mode === 'auto' && (
          <select value={country} onChange={e => setCountryAndSync(e.target.value)} style={{
            background: 'var(--bg-secondary)', border: '1px solid var(--border)', color: 'var(--text-primary)',
            borderRadius: 6, padding: '3px 6px', fontSize: 11,
          }}>
            {Object.entries(COUNTRY_COORDS).map(([code, c]) => (
              <option key={code} value={code}>{c.label}</option>
            ))}
          </select>
        )}
      </div>

      <div style={{ width: 1, height: 20, background: 'var(--border)' }} />

      <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: 'var(--text-secondary)' }}>
        <span>🎨</span>
        <div style={{ display: 'flex', gap: 4 }}>
          {THEMES.map(t => (
            <button key={t.id} onClick={() => setThemeAndSync(t.id)} title={t.label} style={{
              padding: '3px 9px', borderRadius: 6, fontSize: 11, cursor: 'pointer',
              border: theme === t.id ? '1px solid var(--accent)' : '1px solid var(--border)',
              background: theme === t.id ? 'var(--accent-glow)' : 'transparent',
              color: 'var(--text-primary)',
            }}>{t.icon}</button>
          ))}
        </div>
      </div>

      <div style={{ width: 1, height: 20, background: 'var(--border)' }} />

      <div style={{
        display: 'flex', alignItems: 'center', gap: 6, fontSize: 12,
        color: criticalCount > 0 ? 'var(--red)' : 'var(--green)',
      }}>
        <span>{criticalCount > 0 ? '⚠️' : '✅'}</span>
        <span>{criticalCount > 0 ? `${criticalCount} Alert${criticalCount > 1 ? 's' : ''}` : 'All Systems Healthy'}</span>
      </div>
    </div>
  );
}
